import { render, staticRenderFns } from "./LowestLogicalAirfare.vue?vue&type=template&id=0836ebe0&scoped=true&"
import script from "./LowestLogicalAirfare.vue?vue&type=script&lang=js&"
export * from "./LowestLogicalAirfare.vue?vue&type=script&lang=js&"
import style0 from "./LowestLogicalAirfare.vue?vue&type=style&index=0&id=0836ebe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836ebe0",
  null
  
)

export default component.exports